import { render, staticRenderFns } from "./ProjectDocument.vue?vue&type=template&id=2421d55a&scoped=true"
import script from "./ProjectDocument.vue?vue&type=script&lang=js"
export * from "./ProjectDocument.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocument.vue?vue&type=style&index=0&id=2421d55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2421d55a",
  null
  
)

export default component.exports